import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { loadFonts } from './plugins/webfontloader'
import './registerServiceWorker'
import Vue from 'vue';
import Vuex from 'vuex';
import store from './store'
// Vuetify
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { mdi } from 'vuetify/iconsets/mdi'
import * as directives from 'vuetify/directives'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'


let app =  createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)

const vuetify = createVuetify({
  components,
  directives,
  ssr: false,

})

app.use(router)
.use(vuetify)
.mount('#app')

